import { render, staticRenderFns } from "./WYSIWYGBlock.vue?vue&type=template&id=3d6f600c"
import script from "./WYSIWYGBlock.vue?vue&type=script&lang=js"
export * from "./WYSIWYGBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports